<div class="tw:flex tw:flex-col tw:gap-6 tw:p-10 tw:max-sm:p-6 tw:max-sm:max-h-[calc(100dvh_-_2rem)]" cfDialogContent>
  <button cfDialogDismiss class="tw:absolute tw:top-4 tw:right-4">
    <svg class="tw:cursor-pointer tw:text-gray-70" cfIcon="close"></svg>
  </button>
  <div class="tw:space-y-2">
    <h2 class="tw:text-2xl tw:font-semibold tw:leading-loose">{{ "icloud-connect.title" | translate }}</h2>
    <div class="tw:text-base tw:text-gray-60 tw:leading-normal">
      {{ "icloud-connect.hint" | translate | translateCut: 0
      }}<a
        href="https://appleid.apple.com/account/manage"
        cfButton
        class="tw:inline tw:break-words tw:whitespace-normal"
        variant="link"
        target="_blank"
        >{{ "icloud-connect.hint" | translate | translateCut: 1 }}</a
      >{{ "icloud-connect.hint" | translate | translateCut: 2 }}
    </div>
  </div>
  <div [formGroup]="form" class="tw:space-y-4">
    <cf-form-field class="tw:block">
      <cf-input-label> {{ "icloud-connect.email" | translate }} </cf-input-label>
      <input cf-input required formControlName="email" />
      <cf-input-error [error]="form.controls.email.errors"> {{ "icloud-connect.email" | translate }} </cf-input-error>
    </cf-form-field>
    <cf-form-field class="tw:block">
      <cf-input-label> {{ "icloud-connect.password" | translate }} </cf-input-label>
      <input cf-input required formControlName="password" />
      <cf-input-error [error]="form.controls.password.errors">
        {{ "icloud-connect.password" | translate }}
      </cf-input-error>
    </cf-form-field>
  </div>
  @if (customError()) {
    <div class="tw:text-red-50 tw:text-base tw:leading-normal tw:text-center">{{ customError() }}</div>
  }
  <div class="tw:text-base tw:leading-normal">
    {{ "icloud-connect.password-hint" | translate | translateCut: 0 }}
    <span
      class="tw:text-blue-50 tw:cursor-pointer tw:font-medium tw:leading-normal tw:!no-underline tw:inline-flex tw:items-center tw:gap-1"
      (click)="openHint($event)"
    >
      {{ "icloud-connect.password-hint" | translate | translateCut: 1 }}
      <!-- <cf-icon icon="arrow_right" color="blue-50" className="tw:[&_svg]:inline" -->
      <svg cfIcon="arrow_right" class="tw:ml-1 tw:text-blue-50"></svg>
    </span>
  </div>
  <div class="tw:flex tw:items-center tw:gap-4 tw:justify-end">
    <button cfButton variant="secondary" cfDialogDismiss>{{ "cancel" | translate }}</button>
    <button cfButton [loading]="loading()" (click)="connect()">
      <cf-button-loading>{{ "icloud-connect.add-account" | translate }}</cf-button-loading>
    </button>
  </div>
</div>
